import { type JSX } from 'react';
import { Menu, ActionIcon, Text, Badge } from '@mantine/core';
import { IconUser, IconLogout } from '@tabler/icons-react';
import type { AuthRole } from '@/auth/types';

interface AccountMenuProps {
  email: string;
  role: AuthRole;
  onSignOut: () => void;
}

const ROLE_COLORS: Record<AuthRole, string> = {
  admin: 'red',
  content: 'blue',
  smm: 'green',
  customer: 'gray',
};

export function AccountMenu({ email, role, onSignOut }: AccountMenuProps): JSX.Element {
  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <ActionIcon size="lg" variant="subtle" color="gray" aria-label="Account menu">
          <IconUser size={18} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item component="div" style={{ cursor: 'default' }} tabIndex={-1}>
          <Text size="sm" c="dimmed" truncate>
            {email}
          </Text>
          <Badge size="xs" color={ROLE_COLORS[role]} mt={4}>
            {role}
          </Badge>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item leftSection={<IconLogout size={14} />} onClick={onSignOut}>
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
